<template>
    <line-layout :hide_footer="true">
        <div class="container" v-if="!is_loading">
            <div class="row">
                <div class="col-12 mt-5">
                    <h4 class="text-center">ลงทะเบียน</h4>
                </div>
                <div class="col-12">
                    <div class="text-center my-3">
                        <img :src="image" alt="" width="150">
                    </div>
                    <div class="form-group my-3">
                        <label for="">เบอร์โทร <span class="text-danger">*</span></label>
                        <div class="d-flex gap-3">
                            <input type="number" class="form-control" v-model="phone" />
                            <button class="btn btn-sm btn-alt-primary flex-33" id="btn-send-otp"
                                v-on:click="sendOtp()">ส่ง OTP</button>
                        </div>
                    </div>
                    <div class="form-group my-3">
                        <label for="">OTP <span class="text-danger">*</span></label>

                        <div class="d-flex gap-3">
                            <input type="text" class="form-control" name="otp" autocomplete="one-time-code"
                                inputmode="numeric" pattern="\d{6}" required v-model="otp" />
                            <button class="btn btn-sm btn-alt-warning flex-33" v-on:click="verifyOTP()">ตรวจสอบ</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-if="verified">
                <div class="form-group my-3">
                    <label for="">ชื่อ <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" v-model="name" />
                </div>
                <div class="form-group my-3">
                    <label for="">อีเมล</label>
                    <input type="email" class="form-control" v-model="email" />
                </div>
                <div class="col-12">
                    <div class="text-center">
                        <button class="btn btn-alt-primary w-100 mt-3 btn-save" v-on:click="save()">บันทึก</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <line-loading />
        </div>

        <div class="modal fade" id="modal-select-customer" tabindex="-1" aria-labelledby="exampleModalLabel"
            aria-hidden="true" data-bs-keyboard="false">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="exampleModalLabel">ข้อมูลของท่าน</h1>
                    </div>
                    <div class="modal-body" style="height: 280px; overflow-y: auto;">
                        <div class="row">
                            <template v-for="(item, i) in customers">
                                <div class="col-12" v-on:click="selectCustomer(i)">
                                    <div
                                        :class="`card p-3 d-flex flex-column ${selectedCustomer == i ? 'border-primary' : ''}`">
                                        <span>ชื่อ {{ item.fullname }}</span>
                                        <span>อีเมล {{ item.email ? item.email : 'ไม่ระบุ' }}</span>
                                        <span>เบอร์โทร {{ item.phone }}</span>
                                    </div>
                                    <hr>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary"
                            v-on:click="confirmCustomer(null)">ไม่พบรายชื่อ</button>
                        <button type="button" class="btn btn-primary"
                            v-on:click="confirmCustomer(selectedCustomer)">เลือก</button>
                    </div>
                </div>
            </div>
        </div>
    </line-layout>
</template>

<script>
import liff from "@line/liff";
import axios from "axios";
import { Modal } from 'bootstrap';
export default {
    props: ["types", 'url_is_member'],
    data() {
        return {
            name: "",
            phone: "",
            email: "",
            image: "",
            otp: "",
            type: 5,
            line_user_id: null,
            is_loading: true,
            otp: "",
            store_id: null,
            verified: false,
            customers: [],
            selectedCustomer: null,
            modal: null,
            liff_id: null
        };
    },
    async mounted() {
        try {
            localStorage.removeItem('line_user_id');
            localStorage.removeItem('store_id');
            localStorage.removeItem('liff_id');
            const urlParams = new URLSearchParams(window.location.search);
            const storeId = urlParams.get('store_id');
            this.store_id = storeId;
            let resliff = await axios.post("/liff/get-liff-id", {
                store_id: this.store_id
            });
            await liff.init({
                liffId: resliff.data.liff_id, // Use own liffId
            });
            await liff.ready
            this.liff_id = resliff.data.liff_id;
            if (!(await liff.isLoggedIn())) {
                localStorage.removeItem('line_user_id');
                liff.login();
            }
            if (!liff.isInClient()) {
                console.log("ปิด");
                liff.closeWindow()
            }
            const profile = await liff.getProfile();
            this.line_user_id = profile.userId;
            this.image = profile.pictureUrl
            this.is_loading = false;
        } catch (error) {
            window.detectError(error)
        }
    },
    methods: {
        confirmCustomer(i) {
            if (i == null) {
                this.selectedCustomer = null;
                this.modal.hide()
                this.name = null;
                this.type = null;
                this.email = null;
                return;
            }

            this.name = this.customers[i].fullname
            this.type = this.customers[i].type
            this.email = this.customers[i].email
            this.modal.hide()
        },
        selectCustomer(i) {
            this.selectedCustomer = i
        },
        async verifyOTP() {
            let res = await axios.post("/liff/verify-otp", {
                line_user_id: this.line_user_id,
                store_id: this.store_id,
                phone: this.phone,
                otp: this.otp
            })

            if (res.data.success) {
                this.verified = true;
                let customers = res.data.customers;
                if (customers.length == 1) {
                    this.name = customers[0].fullname
                    this.email = customers[0].email
                    this.type = customers[0].type
                } else if (customers.length > 1) {
                    this.customers = customers
                    this.modal = new Modal(document.getElementById('modal-select-customer'))
                    this.modal.show()
                }
            } else {
                this.verified = false;
                alert('OTP ไม่ถูกต้อง');
            }
        },
        async sendOtp() {
            if (!this.phone) {
                alert('กรุณากรอกเบอร์โทร');
                return;
            }
            let res = await axios.post("/liff/send-otp", {
                phone: this.phone,
                line_user_id: this.line_user_id,
                store_id: this.store_id
            })
            const otpBtn = document.getElementById('btn-send-otp');
            let timeLeft = 300;
            otpBtn.disabled = true;
            otpBtn.innerText = ` (${timeLeft}s)`;

            const timer = setInterval(() => {
                timeLeft--;
                otpBtn.innerText = ` (${timeLeft}s)`;

                if (timeLeft <= 0) {
                    clearInterval(timer);
                    otpBtn.disabled = false;
                    otpBtn.innerText = 'ส่ง OTP';
                }
            }, 1000);
            if (res.data.success) {
                alert('ส่ง OTP เรียบร้อย');
            } else {
                alert(res.data.message)
            }
        },
        isValidEmail(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        },
        save() {
            try {
                if (!this.verified) {
                    return alert('กรุณากดตรวจสอบ OTP');
                }
                if (!this.name || !this.phone || !this.type || !this.otp) {
                    alert('กรุณากรอกข้อมูลให้ครบถ้วน');
                    return;
                }
                if (this.email) {
                    if (!this.isValidEmail(this.email)) {
                        alert('รูปแบบอีเมลไม่ถูกต้อง');
                        return;
                    }
                }
                document.querySelector('.btn-save').disabled = true;
                let customer_id = null;
                if (this.customers.length > 0) {
                    customer_id = this.customers[this.selectedCustomer].id;
                }
                this.$emit('confirm', {
                    name: this.name,
                    customer_id: customer_id,
                    phone: this.phone,
                    email: this.email,
                    type: this.type,
                    image: this.image,
                    liff: liff,
                    line_user_id: this.line_user_id,
                    otp: this.otp,
                    store_id: this.store_id,
                });
            } catch (error) {
                window.detectError(error)
            }
        }
    }
};
</script>

<style scoped></style>
